import { trpc } from "@/Utils/trpc";

export const usePricing = (currentTerminalId?: string) => {
  const {
    data: pricing,
    isLoading: isLoadingPricing,
    error: errorFetchingPricing,
    refetch: refetchPricing,
  } = trpc.payments.getPricing.useQuery(
    {
      terminalId: currentTerminalId!,
    },
    {
      enabled: !!currentTerminalId,
      select: (data) => ({
        currency: data?.currency || "",
        price: data?.unit_amount ? `${data.unit_amount / 100}` : "",
      }),
    },
  );

  const { mutateAsync: mutatePricing, isPending: isUpdatingPricing } =
    trpc.payments.setPricing.useMutation({ onSuccess: () => refetchPricing() });

  return {
    pricing,
    isLoadingPricing,
    errorFetchingPricing,
    mutatePricing,
    isUpdatingPricing,
  };
};
